import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let WRadioGroup = class WRadioGroup extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "modelValue", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "translateLabel", void 0);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "dataTest", void 0);
  }
  get innerValue() {
    return this.modelValue;
  }
  set innerValue(val) {
    this.$emit('update:modelValue', val);
  }
  get parsedOptions() {
    if (!this.options || !Array.isArray(this.options)) {
      return [];
    }
    return this.options;
  }
  /**
   * Returns the display label based on the current translation settings.
   *
   * @param {string} label - The label to be translated or displayed as-is.
   * @return {string} The translated label if translation is enabled; otherwise, the original label.
   */
  labelToDisplay(label) {
    if (this.translateLabel) {
      return this.$t(label);
    } else {
      return label;
    }
  }
  handleChange(val) {
    this.$emit('update:modelValue', val);
    this.$emit('change', val);
  }
};
__decorate([Prop()], WRadioGroup.prototype, "modelValue", void 0);
__decorate([Prop({
  default: () => []
})], WRadioGroup.prototype, "options", void 0);
__decorate([Prop({
  default: false
})], WRadioGroup.prototype, "translateLabel", void 0);
__decorate([Prop({
  default: false
})], WRadioGroup.prototype, "disabled", void 0);
__decorate([Prop()], WRadioGroup.prototype, "dataTest", void 0);
WRadioGroup = __decorate([Component({
  emits: ['update:modelValue', 'change']
})], WRadioGroup);
export default WRadioGroup;